import React from 'react';
import { useTheme } from '../../theme';

export default function SectionLabel({ children, style }) {
  const { p, fonts } = useTheme();

  return (
    <div style={{
      fontFamily: fonts.mono,
      fontSize: 11,
      color: p.accent,
      letterSpacing: '.18em',
      textTransform: 'uppercase',
      marginBottom: 24,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      ...style,
    }}>
      <span style={{ display: 'inline-block', width: 24, height: 1, background: p.accent }} />
      {children}
    </div>
  );
}
